// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 18V16H15V18H13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM9.6 10V12H9V12.6H7V10H9.6ZM13 10V12.6H11V12H10.4V10H13ZM9 13.4V14H9.6V16H7V13.4H9ZM17 14V20H11V14H17Z"}}]};

const FilePasteFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-paste-filled',
    ref,
    icon: element,
  },
));

FilePasteFilledIcon.displayName = 'FilePasteFilledIcon';

export default FilePasteFilledIcon;
